import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';

const DeleteDoctorModal = ({ open, onClose, onDelete, doctor }) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Delete Doctor</DialogTitle>
            <DialogContent>
                <Typography variant="body1">
                    {doctor ? (
                        <>Are you sure you want to delete doctor <b>{doctor.name} {doctor.lastname}</b>?</>
                    ) : (
                        <>No doctor selected for deletion.</>
                    )}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="outlined">
                    Cancel
                </Button>
                {doctor && (
                    <Button onClick={() => onDelete(doctor.id)} variant="contained" color="secondary">
                        Delete
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default DeleteDoctorModal;
